import React, { useState, useEffect, useCallback, useRef } from 'react';
import { billingService } from '../services/subscriptionService';
import { useSubscription } from '../providers/SubscriptionProvider';
import { navigateToSubscribe } from '../utils/billingHandoff';
import { isIosShell } from '../utils/platform';

const GOLD = '#C9A84C';

export default function TrialBanner() {
  if (isIosShell()) return null;
  const { openStripeCheckout } = useSubscription();
  const [daysLeft, setDaysLeft] = useState(null);
  const [busy, setBusy] = useState(false);
  const pollRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      const data = await billingService.getBillingStatus();
      if (cancelled) return;
      if (!data) return;

      if (data.status === 'trial' && data.trial_days_remaining <= 7) {
        setDaysLeft(data.trial_days_remaining);
      } else if (data.status === 'active') {
        setDaysLeft(null);
        if (pollRef.current) { clearInterval(pollRef.current); pollRef.current = null; }
      } else {
        setDaysLeft(null);
      }
    };

    check();
    pollRef.current = setInterval(check, 60000);
    return () => { cancelled = true; if (pollRef.current) clearInterval(pollRef.current); };
  }, []);

  const handleSubscribe = useCallback(async () => {
    setBusy(true);
    try {
      const ok = await openStripeCheckout('monthly');
      if (!ok) navigateToSubscribe({ resubscribe: '1' });
    } finally {
      setBusy(false);
    }
  }, [openStripeCheckout]);

  if (daysLeft === null) return null;

  const label = daysLeft === 0
    ? 'Last day'
    : daysLeft === 1
      ? '1 day left'
      : `${daysLeft} days left`;

  return (
    <div
      style={{
        padding: '10px 16px',
        background: 'rgba(201, 168, 76, 0.08)',
        borderBottom: '1px solid rgba(201, 168, 76, 0.15)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
        flexWrap: 'wrap',
      }}
    >
      <span style={{ fontSize: 13, color: GOLD, fontWeight: 600 }}>
        Trial ends in {label}
      </span>
      <button
        onClick={handleSubscribe}
        disabled={busy}
        style={{
          fontSize: 12,
          fontWeight: 700,
          color: GOLD,
          background: 'none',
          border: `1px solid ${GOLD}`,
          borderRadius: 20,
          padding: '5px 14px',
          cursor: busy ? 'wait' : 'pointer',
          transition: 'opacity 0.15s',
          whiteSpace: 'nowrap',
          opacity: busy ? 0.7 : 1,
        }}
      >
        {busy ? 'Opening…' : 'Subscribe now →'}
      </button>
    </div>
  );
}
